module.exports = __webpack_public_path__ + "img/ball2.a3f9c33b.png";